export default __webpack_public_path__ + "static/media/Checo-GPMexico(360x600).ae36eca2.webp";